import { createVNode as s, mergeProps as n } from "vue";
import l from "../node_modules/@pf-ui/pf-icon-svg/es/asn/Close1TwoTone.js";
import m from "../components/PfIcon.js";
const o = (e, r) => {
  const t = {
    ...e,
    ...r.attrs
  };
  return s(m, n(t, {
    icon: l
  }), null);
};
o.displayName = "Close1TwoTone";
o.inheritAttrs = !1;
export {
  o as default
};
